import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DeskBookingChangeService } from '../../../core/services/desk-booking-change.service';
import { DeskExactTimeMoveComponent } from '../desk-exact-time-move/desk-exact-time-move.component';
import { DeskSlotChangeDialogComponent } from '../desk-slot-change-dialog/desk-slot-change-dialog.component';

/** One reviewed desk change at a time, available from every employee route. */
@Component({
  selector: 'im-desk-slot-change-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeskSlotChangeDialogComponent, DeskExactTimeMoveComponent],
  template: `
    @if (changes.exactMove(); as move) {
      <im-desk-exact-time-move [context]="move" [saving]="changes.moveSaving()"
        (selectBooking)="changes.selectExactMoveBooking($event)" (confirmMove)="changes.confirmExactMove()" (closed)="changes.close()" />
    } @else if (changes.context(); as context) {
      <im-desk-slot-change-dialog [context]="context" [preview]="changes.preview()"
        [result]="changes.result()" [busy]="changes.busy()" [error]="changes.error()"
        (requestPreview)="changes.requestPreview($event)" (selectionChanged)="changes.selectionChanged($event)"
        (commit)="changes.commit($event)" (closed)="changes.close()" (undo)="changes.undo($event)" />
    }
  `,
})
export class DeskSlotChangeHostComponent {
  protected readonly changes = inject(DeskBookingChangeService);
}
